import { useEffect, useRef, useState } from "react";
import { apiEndpoint, userIDs } from "./utils";

export default function Best() {
  const [users, setUsers] = useState<null | [{ first_name: string }]>(null);
  const timing = useRef({ start: Date.now(), end: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    userIDs.map((id) =>
      fetch(apiEndpoint)
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          if (!timing.current.end) {
            timing.current.end = Date.now();
          }
          setUsers((prevUsers) => (prevUsers ? [...prevUsers, data] : [data]));
        })
    );
  }, []);
  const { end, start } = timing.current;

  return (
    <div className="App Best">
      <h1>Best case!</h1>
      <h2>
        {loading ? <div id="loading"></div> : "Loaded "}{" "}
        {end && `in ( ${end - start} ms )`}
      </h2>
      <ul>{users && users.map((data) => <li>{data.first_name}</li>)}</ul>
    </div>
  );
}
